import React from 'react';
export const SummaryScreen = ({
  selections,
  onReset
}) => {
  const currentDateTime = new Date().toLocaleString();
  return <div className="bg-white rounded-lg shadow-lg p-6 animate-fade-in" data-id="element-39">
      <h2 className="text-xl font-bold mb-6 text-center" data-id="element-40">Summary</h2>
      <div className="space-y-4 mb-6" data-id="element-41">
        <div className="flex justify-between" data-id="element-42">
          <span className="font-medium" data-id="element-43">Body Position:</span>
          <span data-id="element-44">{selections.bodyPosition}</span>
        </div>
        <div className="flex justify-between" data-id="element-45">
          <span className="font-medium" data-id="element-46">Severity:</span>
          <span data-id="element-47">{selections.severity}</span>
        </div>
        <div className="flex justify-between" data-id="element-48">
          <span className="font-medium" data-id="element-49">Body Part:</span>
          <span data-id="element-50">{selections.bodyPart}</span>
        </div>
        <div className="flex flex-col" data-id="element-51">
          <span className="font-medium mb-2" data-id="element-52">Symptoms:</span>
          <div className="flex flex-wrap gap-2" data-id="element-53">
            {selections.symptoms.map(symptom => <span key={symptom} className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm" data-id="element-54">
                {symptom}
              </span>)}
          </div>
        </div>
        <div className="flex justify-between pt-4 border-t border-gray-200" data-id="element-55">
          <span className="font-medium" data-id="element-56">Date & Time:</span>
          <span data-id="element-57">{currentDateTime}</span>
        </div>
      </div>
      <div className="flex flex-col space-y-3" data-id="element-58">
        <button className="w-full py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-colors" data-id="element-59">
          Confirm
        </button>
        <button className="w-full py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors" onClick={onReset} data-id="element-60">
          Start Over
        </button>
      </div>
    </div>;
};